import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail-supplier/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail-supplier/update-status',
    method: 'put',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail-supplier/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail-supplier/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail-supplier/update',
    method: 'put',
    data: data
  })
}

export function getMaterialDetailSupplierList() {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail-supplier/common-list',
    method: 'get'
  })
}





// WEBPACK FOOTER //
// ./src/api/master_material_detail_supplier.js